import { QrCode, RefreshCw, Lock, Printer } from "lucide-react";
import { PageHero, SectionHeading } from "../components/common/SectionHeading";
import { StepsSection } from "../components/sections/StepsSection";
import { PrivacySection } from "../components/sections/PrivacySection";
import { ScannerDemoSection } from "../components/sections/ScannerDemoSection";
import { CtaBand } from "../components/sections/CtaBand";
import { usePageTitle } from "../lib/usePageTitle";

const DYNAMIC = [
  { icon: QrCode, title: "The QR holds an ID, not you", body: "Each sticker encodes a short link with your CARLINK ID, such as /v/CL-8X92K7. Your name and number are never printed or encoded." },
  { icon: RefreshCw, title: "Update details, keep the sticker", body: "Because the link points to your CARLINK ID, you can change your phone number or contact preferences without replacing the sticker." },
  { icon: Lock, title: "Only active stickers respond", body: "A sticker can be paused or retired — for example if it's damaged or the vehicle is sold — so it stops working immediately." },
  { icon: Printer, title: "One QR, every format", body: "The PNG, printable PDF and sticker you'll be able to download all carry the same QR and the same CARLINK ID." },
];

const DynamicQr = () => (
  <section className="section-pad border-t border-white/5">
    <div className="container-x">
      <SectionHeading label="Dynamic QR" title="Why your sticker keeps working." />
      <div className="mt-14 grid gap-5 sm:grid-cols-2">
        {DYNAMIC.map(({ icon: I, title, body }) => (
          <article key={title} className="card-premium p-7 lg:p-9">
            <I className="h-6 w-6 text-[#FF5500]" aria-hidden="true" />
            <h3 className="mt-6 font-display text-xl font-semibold text-slate-50">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">{body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default function HowItWorksPage() {
  usePageTitle("How It Works");
  return (
    <>
      <PageHero label="How it works" title="A sticker on the glass. A secure link behind it." body="CARLINK connects your physical vehicle to a private digital identity, so anyone nearby can reach you without ever seeing your number." />
      <StepsSection label="For owners" title="Register. Get your ID. Stay reachable." />
      <DynamicQr />
      <PrivacySection />
      <ScannerDemoSection />
      <CtaBand />
    </>
  );
}
